import httpClient from './httpClient';
 import { LAST_TIME_LOG_REF_PATH } from '../constants/chat';
 import firebase from "@/services/firebase";
 const chatService = {
    getConversations(params = {}) {
      const link = 
        `/api/conversations/user`;

      return httpClient
        .get(link, { params })
        .then(response => response.conversations)
        .catch(e => {
          return { success: false, message: e };
        });
    },
    
    generateFirebaseToken() {
      return httpClient
        .get(`/api/chat/auth`)
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });
    },
  
    uploadFile(body) {
      return httpClient.post('/api/chat/files-upload', body, {
        header : {
          'Content-Type' : 'multipart/form-data'
        }
      })
    },
    getFile(id) {
      return httpClient.get('/api/chat/files-upload/'+id
      )
    },

    logChatActivity(body) {
      return httpClient.post('/api/chat/log-chat-activity', body);
    },

    getUnreadConversationCount( ) {
      const params = {
        isBackground: true
      }
      return httpClient
      .get(`/api/conversations/unread-count`, {params})
      .then(response => response)
      .catch(e => {
        return { success: false, message: e };
      });
    },

    getSettings() {
      return httpClient.get('/api/chat/configurations')
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });;
    },
    getChatCharte() {
      return httpClient.get('/api/adv/chat/charte')
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });
    },
    updateChatCharte(data) {
      return httpClient.put('/api/adv/chat/charte', data)
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });;
    },
    getChatCharte() {
      return httpClient.get('api/adv/chat/charte')
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });
    },
    updateChatCharte(data) {
      return httpClient.put('api/adv/chat/charte', data)
        .then(response => response)
        .catch(e => {
          return { success: false, message: e };
        });;
    },
    logTheLastTimeOfMessage(path, lastTime) {
      return  firebase.database().ref(`${path}`).set(lastTime);
    },
  
    getLastTimeOfMessage(conversationId) {
      return new Promise((resolve, reject) => {
        firebase.database().ref(`${LAST_TIME_LOG_REF_PATH}/${conversationId}`).once('value',(snapshot) => {
          const data = snapshot.val() ? snapshot.val() : '';

          resolve(data)
        });
      })
    }
}

export default chatService;